var $=jQuery;
jQuery(document).ready(function ($) {
  $('.footer-block.has-dropdown h2.footer-block__heading').click(function (e) { 
      e.preventDefault();
      $(this).toggleClass('active');
  });
  $('.close-notification-bar').click(function (e) { 
    e.preventDefault();
    $('.notification-bar').fadeOut();
  });
  $('li.has-submenu svg.icon.icon-caret').click(function (e) { 
    e.preventDefault();
    $(this).toggleClass('active');
  });
  $('.product__text_box .svg-wrapper').click(function (e) { 
    e.preventDefault();
    $('.product__text_box').slideToggle();
  });
   $('.show-more-btn').click(function (e) { 
        e.preventDefault();
        $(this).hide();
        $('.image-with-text__text').removeClass('show-more');
    });
    $(document).on('click','.facets-vertical .active-facets-vertical-filter',function (e) { 
        e.preventDefault();
        $('.facets-vertical .facets-wrapper').toggleClass('active');
    });
    $('body').on('click', 'span.facet-checkbox__text,.facets-layout-list--swatch input[type=checkbox]', function() {
      setTimeout(function() { 
        run_callbak_filter()
      }, 10);
    });
    $('body').on('change', '.facets__price .field__input', function() {
      setTimeout(function() { 
        run_callbak_filter()
      }, 1000);
    });
  
    function run_callbak_filter(){
      $('.facets-vertical .facets-wrapper').removeClass('active');
    }
    $(".product-single__thumbnails").flickity({
      pageDots: false,
      freeScroll: false,
      wrapAround: true,
      prevNextButtons: true,
      autoPlay: false,
      groupCells: false,
      cellAlign: 'left',
     asNavFor: '.product-single__gallery'
    });
});


class PriceRange1 extends HTMLElement {
  connectedCallback() {
    this.rangeLowerBound = this.querySelector(".price-range__range-group input:first-child");
    this.rangeHigherBound = this.querySelector(".price-range__range-group input:last-child");
    this.textInputLowerBound = this.querySelector(".price-range__input:first-child input");
    this.textInputHigherBound = this.querySelector(".price-range__input:last-child input");

    // Event listeners for text input focus and change
    this.textInputLowerBound.addEventListener("focus", () => this.textInputLowerBound.select());
    this.textInputHigherBound.addEventListener("focus", () => this.textInputHigherBound.select());

    this.textInputLowerBound.addEventListener("change", (event) => {
      const newValue = Math.max(Math.min(parseInt(event.target.value), parseInt(this.textInputHigherBound.value || event.target.max) - 1), event.target.min);
      event.target.value = newValue;
      this.rangeLowerBound.value = newValue;
      this.updateRangeStyles();
    });

    this.textInputHigherBound.addEventListener("change", (event) => {
      const newValue = Math.min(Math.max(parseInt(event.target.value), parseInt(this.textInputLowerBound.value || event.target.min) + 1), event.target.max);
      event.target.value = newValue;
      this.rangeHigherBound.value = newValue;
      this.updateRangeStyles();
    });

    // Event listeners for range slider change and input
    this.rangeLowerBound.addEventListener("change", (event) => {
      this.textInputLowerBound.value = event.target.value;
      this.textInputLowerBound.dispatchEvent(new Event("change", { bubbles: true }));
    });

    this.rangeHigherBound.addEventListener("change", (event) => {
      this.textInputHigherBound.value = event.target.value;
      this.textInputHigherBound.dispatchEvent(new Event("change", { bubbles: true }));
    });

    this.rangeLowerBound.addEventListener("input", (event) => {
      this.dispatchEvent(new CustomEvent("collection:abort-loading", { bubbles: true }));
      event.target.value = Math.min(parseInt(event.target.value), parseInt(this.textInputHigherBound.value || event.target.max) - 1);
      this.textInputLowerBound.value = event.target.value;
      this.updateRangeStyles();
    });

    this.rangeHigherBound.addEventListener("input", (event) => {
      this.dispatchEvent(new CustomEvent("collection:abort-loading", { bubbles: true }));
      event.target.value = Math.max(parseInt(event.target.value), parseInt(this.textInputLowerBound.value || event.target.min) + 1);
      this.textInputHigherBound.value = event.target.value;
      this.updateRangeStyles();
    });
  }

  updateRangeStyles() {
    this.rangeLowerBound.parentElement.style.setProperty("--range-min", `${(parseInt(this.rangeLowerBound.value) / parseInt(this.rangeLowerBound.max)) * 100}%`);
    this.rangeHigherBound.parentElement.style.setProperty("--range-max", `${(parseInt(this.rangeHigherBound.value) / parseInt(this.rangeHigherBound.max)) * 100}%`);
  }
}

window.customElements.define("price-range1", PriceRange1);


//Swipper slider
document.addEventListener('DOMContentLoaded', function() {
    new Swiper('.slider-column', { 
      loop: true,
      navigation: {
        nextEl: '.slider-column-arrow .swiper-button-next',
        prevEl: '.slider-column-arrow .swiper-button-prev',
      },
      autoplay: {
        delay: 5000, 
      },
      breakpoints: {
        0: {
          slidesPerView: "auto",
          centeredSlides: true,
          spaceBetween: 20
        }
      }
    });
});
document.addEventListener('DOMContentLoaded', function() {
    new Swiper('.has-slider', { 
      loop: true,
      pagination: {
        el: ".swiper-pagination",
        clickable: true,
      },
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
      autoplay: {
        delay: 50000, 
        disableOnInteraction: false, 
      },
      breakpoints: {
        300: {
          slidesPerView: 3, 
          spaceBetween: 10
        },
        991: {
          slidesPerView: 4, 
          spaceBetween: 15
        }
      }
    });
});
document.addEventListener('DOMContentLoaded', function() {
    var swiper = new Swiper('.slider-two-column', { 
        loop: true,
        slidesPerView: 2,
        slidesPerGroup: 2, // Move two slides per click
        pagination: {
            el: ".swiper-pagination",
            clickable: true,
        },
        navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
        },
        autoplay: {
            delay: 50000, 
            disableOnInteraction: false, 
        },
        breakpoints: {
            300: {
                slidesPerView: 2,
                spaceBetween: 20,
                slidesPerGroup: 2, // Move one slide at a time on small screens
            },
            991: {
                slidesPerView: 2,
                spaceBetween: 60,
                slidesPerGroup: 2, // Move two slides per click on large screens
            }
        },
        on: {
            init: function () {
                console.log('Swiper initialized');
            },
            slideChange: function () {
                console.log('Slide changed');
            }
        }
    });
    swiper.update();
});

//Swipper slider
$(document).ready(function(){
  ///// Tab Faq
  $(document).on('click','.acctab_title', function(e){
     if($(window).width() >= 768){
        $('.acctab_title').removeClass('active-accor');
        $(this).addClass('active-accor');
        $('.acc_tab-inner .acc-tab-content .tabs-content').removeClass('activemain-tab').hide();
        $($(this).attr('data-act-title')).addClass('activemain-tab').show();
     }else{
       $('.acctab_title').removeClass('active-accor');
        $(this).addClass('active-accor');
        $('.acc_tab-inner .acc-tab-content .tabs-content').removeClass('activemain-tab').hide();
        $($(this).attr('data-act-title')).addClass('activemain-tab').show();
        // $('.acc_tab-inner .acc-tab-content .tabs-content').removeClass('activemain-tab').hide();
        $('.acc_tab-inner .acc-tab-content').addClass('tab-content-show').show();
        $($(this).attr('data-act-title')).addClass('activemain-tab').show();
     }
  });
  $(document).on('click','.acc_tab-inner .acc-tab-content .back__arrow', function(e){
      $('.acc_tab-inner .acc-tab-content').removeClass('tab-content-show').show();
  });
  $('.acc-head').on('click', function() {
      if($(this).hasClass('active')) {
        $(this).siblings('.acc-content').slideUp();
        $(this).removeClass('active');
      }
      else {
        $('.acc-content').slideUp();
        $('.acc-head').removeClass('active');
        $(this).siblings('.acc-content').slideToggle();
        $(this).toggleClass('active');
      }
  });
  ///// Tab Faq
});
 document.addEventListener('DOMContentLoaded', function() {
    const loadMoreButton = document.querySelector('[data-pagination-btn]');
    const productGrid = document.getElementById('product-grid');
    
    if (loadMoreButton) {
        loadMoreButton.addEventListener('click', function(e) {
            e.preventDefault();
            const nextUrl = loadMoreButton.getAttribute('href');
            
            loadMoreButton.textContent = "Laden...";
            loadMoreButton.setAttribute('disabled', 'true');
            
            fetch(nextUrl)
                .then(response => response.text())
                .then(data => {
                    const tempDiv = document.createElement('div');
                    tempDiv.innerHTML = data;
                    
                    const newProducts = tempDiv.querySelector('#product-grid').innerHTML;
                    
                    productGrid.innerHTML += newProducts;
                    
                    var sliderProducts = document.querySelectorAll('.has-slider-wrapper');

                    sliderProducts.forEach(function(slider) {
                        new Flickity(slider, {
                            pageDots: false,
                            freeScroll: false,
                            wrapAround: true,
                            prevNextButtons: true,
                            autoPlay: false,
                            groupCells: false,
                            cellAlign: 'center',
                        });
                    });
                    
                    const newButton = tempDiv.querySelector('[data-pagination-btn]');
                    if (newButton) {
                        loadMoreButton.setAttribute('href', newButton.getAttribute('href'));
                        loadMoreButton.textContent = "MEHR ANZEIGEN";
                        loadMoreButton.removeAttribute('disabled');
                    } else {
                        loadMoreButton.textContent = "Keine Produkte mehr";
                    }
                })
                .catch(error => {
                    console.error('Error loading more products:', error);
                    loadMoreButton.textContent = "Try again";
                    loadMoreButton.removeAttribute('disabled');
                });
        });
    }
});


